// clinic-telehealth-book-at (2026-10): the "Book at" list for a WS location
// login, and the Saturday rule for the booking calendar.
//
// Both are READS of what the server decided. The server publishes the
// login's extra booking sites (`/auth/me` -> booking_extra_codes, from
// CLINIC_TELEHEALTH_BOOK_LOCATIONS) and whether a location takes Saturday
// bookings (`/crm/raintree/slots` -> saturday_booking, from
// WS_SATURDAY_BOOKING_LOCATIONS). With both settings empty these return
// exactly what the screen had before.

// Append the login's extra booking sites after its own sites.
// * Extra rows bypass the therapy filter (Telehealth's roster therapy need
//   not say "physical" to serve a PT patient).
// * One row per code, never a network row, never a code already listed.
// * Each is tagged `booking_extra: true` so the booking modal knows the
//   server will accept THTX only there.
// No extra codes: the SAME array comes back, so nothing re-renders.
export function appendBookingExtras(ownList, allLocations, extraCodes) {
  const codes = (extraCodes || []).filter(Boolean);
  if (!codes.length) return ownList;
  const out = [...(ownList || [])];
  const have = new Set(out.map((l) => l.raintree_code));
  for (const code of codes) {
    if (have.has(code)) continue;
    const rows = (allLocations || [])
      .filter((l) => l.raintree_code === code && !l.is_network)
      .sort((a, b) => String(a.id).localeCompare(String(b.id)));
    if (!rows.length) continue;
    out.push({ ...rows[0], booking_extra: true });
    have.add(code);
  }
  return out;
}

// A Saturday may be picked only where the server said Saturdays are open
// AND Raintree returned at least one slot that day. Sunday never.
export function saturdayOpen(date, saturdayBooking, slotCount) {
  return !!saturdayBooking && date.getDay() === 6 && slotCount > 0;
}
